export default __webpack_public_path__ + "static/media/TOYOTA04.012fb24a.png";